<i *ngIf="style === 'duotone'" class="ki-duotone ki-{{ICON}} {{customClasses}}" [ngStyle]="customStyles" >
    <i class="path1"></i>
    <i class="path2"></i>
    <i class="path3"></i>
    <i class="path4"></i>
    <i class="path5"></i>
    <i class="path6"></i>
</i>

<i *ngIf="style === 'outline'" class="ki-outline ki-{{ICON}} {{customClasses}}" [ngStyle]="customStyles"></i>

<i *ngIf="style === 'solid'" class="ki-solid ki-{{ICON}} {{customClasses}}" [ngStyle]="customStyles"></i>
